export default "__VITE_ASSET__CiQeRQA1__"